import axios from "axios";
import { authHeaderJson, authHeaderTextPlainJsonPatch } from "../auth-header.service";
import moment from "moment";
import { requestExportToken } from "../export.service";



const getContractPartieElementLog = async (elementId) => {
    const token = await requestExportToken("partida/log");
    return axios.get(`/api/Partida/partida/log/${elementId}?exportToken=${token}`, { headers: authHeaderJson() });
};

const getPresentacionPartidaHome = (elementId) => {
    return axios.get(`/api/Partida/item/presentacion/${elementId}`, { headers: authHeaderJson() } );
};

const getListFullPartidasSubPartidasPolinomios = (elementId) => {
    return axios.get(`/api/Partida/list/fullpartida/${elementId}`, { headers: authHeaderJson() } );
};

const getItemPartida = (partieId) => {
    return axios.get(`/api/Partida/item/partida?partida_id=${partieId}`, { headers: authHeaderJson() } );
};

const getItemSubPartida = (subPartieId) => {
    return axios.get(`/api/Partida/item/subpartida?sub_partida_id=${subPartieId}`, { headers: authHeaderJson() } );
};

const getListPolinomiosPartidaSubpartida = (isPartie, id) => {
    return axios.get(`/api/Partida/list/partidapolinomios?es_Partida=${isPartie}&id=${id}`, { headers: authHeaderJson() } );
};

const getItemPolinoio = (polynomyId = 0) => {
    return axios.get(`/api/Partida/item/polinomio?polinomio_id=${polynomyId}`, { headers: authHeaderJson() } );
};

const getCargaPartida = (elementId) => {
    return axios.get(`/api/Partida/carga/partida/${elementId}`, { headers: authHeaderJson() } );
};

const getCargaSubPartida = (elementId, partidaId = 0) => {
    return axios.get(`/api/Partida/carga/subpartida/${elementId}/${partidaId}`, { headers: authHeaderJson() } );
};

const getCargaPolinomio = () => {
    return axios.get(`/api/Partida/carga/polinomio`, { headers: authHeaderJson() } );
};

const getContratoDI = (elementId) => {
    return axios.get(`/api/Partida/list/contratodi/${elementId}`, { headers: authHeaderJson() } );
};


const setContratoDI = (elementId, listComponent) => {
    return axios.post(`/api/Partida/set/contratodi/list/${elementId}`, listComponent.l_result, { headers: authHeaderJson() } );
}

const setItemPartida = (objPartie) => {
    return axios.post(`/api/Partida/set/partida`, objPartie, { headers: authHeaderJson() } );
}

const setItemSubpartida = (objSubPartie) => {
    return axios.post(`/api/Partida/set/subpartida`, objSubPartie, { headers: authHeaderJson() } );
}

const setItemPolinomio = (objPolynomy) => {
    return axios.post(`/api/Partida/set/polinomio`, objPolynomy, { headers: authHeaderJson() } );
}

const getPolinomioValorBase = (nemoTIndicador, startDate, endDate) => {
    let qs_nemoTIndicador = nemoTIndicador !== null ? `nemoT_indicador=${nemoTIndicador}` : '';
    let qs_periodStartDate = startDate !== null && startDate !== undefined ? `&dtIni=${encodeURIComponent(moment(startDate).format('MM/DD/YYYY'))}` : '';
    let qs_periodEndsDate = endDate !== null && endDate !== undefined ? `&dtFin=${encodeURIComponent(moment(endDate).format('MM/DD/YYYY'))}` : '';
    return axios.get(`/api/Partida/list/polinomio/valorbase?${qs_nemoTIndicador}${qs_periodStartDate}${qs_periodEndsDate}`, { headers: authHeaderJson() } );
}

const getValidateCierrePartidas = (elementId) => {
    return axios.get(`/api/Partida/validate/cierrepartidas/${elementId}`, { headers: authHeaderJson() } );
};

const setCierrePartidas = (elementId, objCierre) => {
    return axios.post(`/api/Partida/set/validate/cierrepartidas/${elementId}`, objCierre, { headers: authHeaderJson() } );
};

const deletePolinomio = (polinomioId) => {
    return axios.delete(`/api/Partida/delete/polinomio/${polinomioId}`, { headers: authHeaderJson() });
};

const deletePartie = (partidaId) => {
    return axios.delete(`/api/Partida/delete/partida/${partidaId}`, { headers: authHeaderJson() });
};

const deleteSubPartie = (subPartidaId) => {
    return axios.delete(`/api/Partida/delete/subpartida/${subPartidaId}`, { headers: authHeaderJson() });
};

export {
    getContractPartieElementLog,
    getPresentacionPartidaHome,
    getListFullPartidasSubPartidasPolinomios,
    getItemPartida,
    getItemSubPartida,
    getListPolinomiosPartidaSubpartida,
    getItemPolinoio,
    getCargaPartida,
    getCargaSubPartida,
    getCargaPolinomio,
    getContratoDI,
    setContratoDI,
    setItemPartida,
    setItemSubpartida,
    setItemPolinomio,
    getPolinomioValorBase,
    getValidateCierrePartidas,
    setCierrePartidas,
    deletePolinomio,
    deletePartie,
    deleteSubPartie
}